<template>
  <section class="w-full xl:w-1/2 bg-teal-300 bg-opacity-90 flex flex-col justify-center items-center text-white space-y-8">
    <h2 class="text-5xl font-bold tracking-wide">{{heading}}</h2>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'PromoOverlay',

  props: ['heading']
};
</script>

<style scoped>
  s {
    text-decoration: none;
    position: relative;
    display: inline-block;
  }

  s:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 8px solid #F24C0D;
    height: calc(50% + 3px);
    width: 100%;
    opacity: .85;
  }
</style>